module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-3-p-286f6301a553278898ef8c269919a033.gif";